module.exports = __webpack_public_path__ + "static/schema-theory-6ea19fce2e8e5b5de4ab3de32c62c49c.png";